import { Injectable, inject } from '@angular/core';
import {
  AddInterestDocument,
  AddInterestMutationVariables,
  AddInterestResult,
  InterestAction,
  InterestType,
  RemoveInterestDocument,
  RemoveInterestMutationVariables,
  RemoveInterestResult,
} from '@shared/graphql/api.generated';
import { GraphqlClients, GraphqlService } from '@shared/graphql/graphql.service';

@Injectable()
export class InterestService {
  private readonly graphqlService = inject(GraphqlService);

  addInterest(itemID: string, action: InterestAction, intType: InterestType) {
    return this.graphqlService.makeMutation<AddInterestResult, AddInterestMutationVariables>(
      GraphqlClients.api,
      AddInterestDocument,
      {
        action,
        intType,
        itemID,
      },
    );
  }

  removeInterest(itemID: string, intType: InterestType) {
    return this.graphqlService.makeMutation<RemoveInterestResult, RemoveInterestMutationVariables>(
      GraphqlClients.api,
      RemoveInterestDocument,
      {
        intType,
        itemID,
      },
    );
  }
}
